import { ReactElement } from 'react';

import { StandardSpinner, TestableComponentProps } from '@dreryk/react-components';

import { PrescriptionCard } from '../../prescription/PrescriptionCard';

type DraftPrescriptionCardSkeletonProps = TestableComponentProps & {
   readonly heading: ReactElement;
   readonly subheading: ReactElement;
};

export const DraftPrescriptionCardSkeleton = (props: DraftPrescriptionCardSkeletonProps): JSX.Element => {
   const { heading, subheading, testId } = props;

   return <PrescriptionCard testId={testId} heading={heading} subheading={subheading} options={<StandardSpinner />} />;
};
